import { axiosInstance } from '.';
const getCancellationPolicyConstants = async () => await axiosInstance.get('/app_constants/cancellation_policy');
const getMimarConstants = async () => await axiosInstance.get('app_constants/settlement_constants');
const updateAppConstants = async (params) => await axiosInstance.patch('/app_constants/update_constants', params);
export {
    getCancellationPolicyConstants,
    getMimarConstants,
    updateAppConstants,
}